import request from '@/utils/request'

// 管理中心首页，接入教室/老师/直播数量统计：
const statisticsDataOperationData = () => {
  return request({
    url: '/admin/statisticsData/operationData',
    method: 'get'
  })
}

// 课堂类型数据统计：
const statisticsDataLiveTypeCount = () => {
  return request({
    url: '/admin/statisticsData/liveTypeCount',
    method: 'get'
  })
}

// 直播数量统计：
const statisticsDataLiveCount = (params) => {
  return request({
    url: '/admin/statisticsData/liveCount',
    method: 'get',
    params
  })
}

// 直播时长统计：
const statisticsDataLiveTimeCount = () => {
  return request({
    url: '/admin/statisticsData/liveTimeCount',
    method: 'get'
  })
}

// 获取录像资源
const getRecordSourceData = (params) => {
  return request({
    url: '/admin/statistics/recordSourceData',
    method: 'get',
    params
  })
}

// 获取学期直播数量
const getTermLiveNum = (params) => {
  return request({
    url: '/admin/statistics/termLiveNum',
    method: 'get',
    params
  })
}

// 数据总览
const getDataOverview = (params) => {
  return request({
    url: '/admin/statistics/dataOverview',
    method: 'get',
    params
  })
}

// 教室启用情况
const getClassroomUseage = (params) => {
  return request({
    url: '/admin/statistics/classroomUsage',
    method: 'get',
    params
  })
}

// 直播排行
const getLiveRanking = (params) => {
  return request({
    url: '/admin/statistics/liveRanking',
    method: 'get',
    params
  })
}

export default {
  statisticsDataOperationData,
  statisticsDataLiveTypeCount,
  statisticsDataLiveCount,
  statisticsDataLiveTimeCount,

  getRecordSourceData,
  getTermLiveNum,
  getDataOverview,
  getClassroomUseage,
  getLiveRanking
}
